export default {
  welcome: 'Welkom',
  we_miss_you: 'We missen je',
  happy_friday: 'Fijne vrijdag',
  lazy_sunday: 'Luie zondag',
  loyalty_program: 'Loyaliteitsprogramma',
  you_might_also_like: 'Misschien vind je dit ook leuk',
  storefront_promo: 'Winkelpromotie',
  welcome_members_club: 'Welkom ledenclub',
  launch_deal: 'Lanceringsdeal',
};
